export default function ReferenceWidgetTemplate(data) {
    //language=HTML
    return `
        <div class="_ref ${data.elementId}comboContainer nama-ref-container">
            <input id="${data.elementId}" name="${data.nameAttr}" class="w-100 combobox ref-textbox"/>
            <a id="${data.searchBtnId}" role="button" href><i class="fa-solid fa-search text-secondary px-1"></i></a>
            <a role="button" id="${data.createBtnId}"><i class="fa-solid fa-arrow-right text-secondary px-1"></i></a>
        </div>
        <div class="name w-handle ${data.elementId}linkContainer">
            <a class="ref_link text-primary" id="${data.elementId}link"></a>
        </div>`;
}